import { withEditableArea } from '@trendkite/ui';

import EditStorySpokespeople from './EditStorySpokespeople';
import StorySpokespeopleDisplay from './StorySpokespeopleDisplay';

export default withEditableArea(
  StorySpokespeopleDisplay,
  EditStorySpokespeople,
);
